module.exports = __webpack_public_path__ + "static/media/image-fallback-icon.564eb7b7.png";